import { Component, Input, OnInit } from '@angular/core';

export interface TimelineEvent {
  date: Date;
  title: string;
  doctor: string;
  type: 'OPD' | 'IPD' | 'Lab' | 'Billing';
  status: string;
  details?: string;
  icon: string;
}

@Component({
  selector: 'app-clinical-timeline',
  templateUrl: './clinical-timeline.component.html',
  styleUrls: ['./clinical-timeline.component.scss']
})
export class ClinicalTimelineComponent implements OnInit {
  @Input() events: TimelineEvent[] = [];

  constructor() {}

  ngOnInit(): void {
    // In a real scenario, this would be fetched from the backend via an Encounter/History API
    // Now receiving this data from the parent OpdDashboardComponent
  }
}
